import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Navigation, Autoplay } from "swiper/modules";
import { Container, Box, useMediaQuery, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

const images = [
  "/assets/images/Top_Skills.svg",
  "/assets/images/Skill_Insights.svg",
  "/assets/images/Role_Suggestion_of_skill.svg",
  "/assets/images/Annual_Income_Based_On.svg",
  "/assets/images/Interview_Question.svg",
];

const FeaturesCardSwiper = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const isLarge = useMediaQuery(theme.breakpoints.down("lg"));
  const isXLLarge = useMediaQuery(theme.breakpoints.down("xl"));

  // Determine slides per view based on screen size
  const getSlidesPerView = () => {
    if (isMobile) return 1; // Mobile: 1 slide
    if (isTablet) return 2; // Tablet: 2 slides
    if (isLarge) return 3; // Large devices: 3 slides
    if (isXLLarge) return 3;
    return 3; // XL devices: 4 slides
  };

  return (
    <Container maxWidth="lg" sx={{ p: "0Px" }}>
      <Box
        sx={{
          width: "100%",
          height: { xs: 160, sm: 200, md: 260 },
          mx: "auto",
          position: "relative",
        }}
      >
        {/* Custom Navigation Buttons - Only show on non-mobile devices */}
        {!isMobile && (
          <>
            <IconButton
              className="swiper-button-prev-custom"
              sx={{
                position: "absolute",
                left: -50,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 10,
                backgroundColor: "#6c5ce7",
                color: "white",
                width: 28,
                height: 28,
                "&:hover": {
                  backgroundColor: "#5a4fcf",
                },            
              }}
            >
              <ChevronLeft sx={{ fontSize: 24 }} />
            </IconButton>

            <IconButton
              className="swiper-button-next-custom"
              sx={{
                position: "absolute",
                right: -50,
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 10,
                backgroundColor: "#6c5ce7",
                color: "white",
                width: 28,
                height: 28,
                "&:hover": {
                  backgroundColor: "#5a4fcf",
                },            
              }}
            >
              <ChevronRight sx={{ fontSize: 24 }} />
            </IconButton>
          </>
        )}

        <Swiper
          modules={[Autoplay, Navigation]}
          slidesPerView={getSlidesPerView()}
          navigation={
            isMobile
              ? false
              : {
                  prevEl: ".swiper-button-prev-custom",
                  nextEl: ".swiper-button-next-custom",
                }
          }
          spaceBetween={isMobile ? 12 : 6}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          centeredSlides="true"
          breakpoints={{
            // Mobile
            320: {
              slidesPerView: 1,
              spaceBetween: 12,
            },
            // Tablet
            768: {
              slidesPerView: 2,
              spaceBetween: 8,
            },
            // Desktop
            1024: {
              slidesPerView: 3,
              spaceBetween: 6,
            },
            // XL
            1280: {
              slidesPerView: 3,
              spaceBetween: 6,
            },
          }}
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          {images.map((src, index) => (
            <SwiperSlide key={index}>
              <img
                src={src}
                alt={`Feature ${index + 1}`}
                style={{
                  display: "block",
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  borderRadius: 12,
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Container>
  );
};

export default FeaturesCardSwiper;
